import { useGetUserProfileByAddress } from '@/api/query'
import { AvatarCircle } from '@/components/atoms/Avatar'
import { Box, Flex, ResponsiveValue } from '@chakra-ui/react'

export const GameParticipants = ({
  players,
  winner,
  size = 'md',
  maxLength = 4,
}: {
  players: Array<string>
  winner: string
  size?: ResponsiveValue<string>
  maxLength?: number
}) => {
  const offset = size === 'md' ? 24 : 16

  return (
    <Flex alignItems={'center'}>
      {players
        .filter((address) => address !== winner)
        .slice(0, maxLength)
        .map((address, index) => {
          return (
            <Box
              key={address}
              w={size === 'md' ? '54px' : '38px'}
              h={size === 'md' ? '54px' : '38px'}
              marginLeft={index ? -offset + 'px' : 0}
              pos={'relative'}
            >
              <PlayerAvatar size={size} address={address} />
            </Box>
          )
        })}
      {players.length > maxLength + 1 && (
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          position={'relative'}
          h={size === 'md' ? 12 : 8}
          w={size === 'md' ? 12 : 8}
          marginLeft={-offset + 'px'}
          rounded={'full'}
          bg={'#5048A3'}
          fontSize={size}
        >
          +{players.length - maxLength - 1}
        </Flex>
      )}
    </Flex>
  )
}

const PlayerAvatar = ({ address, size = 'md' }: { address: string; size?: ResponsiveValue<string> }) => {
  const { data } = useGetUserProfileByAddress(address)

  return (
    <Box border={'1px solid'} p={'2px'} borderColor={'brand.error'} rounded={'full'} position={'relative'}>
      <AvatarCircle size={size} src={data?.user?.profileAvatar} />
    </Box>
  )
}
